import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78721848"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "logo-wrapper",
  href: "#"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "TESLA"),
  /*#__PURE__*/_createElementVNode("span", null, "LABZ")
], -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div id=\"info\" data-v-78721848><h3 data-v-78721848>Часы обработки заявок</h3><div class=\"description\" data-v-78721848><p data-v-78721848>ПН-ПТ: 10:00 - 20:00</p><p data-v-78721848>(московское время, UTC+3)</p></div></div><div id=\"contacts\" data-v-78721848><h3 data-v-78721848>Контакты:</h3><a class=\"tovk\" href=\"https://t.me/+aSkMrcMrGY85M2My\" data-v-78721848>Чат Telegram</a><p class=\"description\" data-v-78721848>↑Обращаться по любым вопросам</p></div>", 2)

import getImage from '@/tools/getImage';

export default /*#__PURE__*/_defineComponent({
  __name: 'PageFooter',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("section", null, [
      _createElementVNode("a", _hoisted_1, [
        _createElementVNode("img", {
          src: _unref(getImage)('logo.webp'),
          alt: "logo image"
        }, null, 8, _hoisted_2),
        _hoisted_3
      ]),
      _hoisted_4
    ])
  ]))
}
}

})